<template>
    <v-col cols="12" :order="orderXs" v-bind:id="'category-prod-'+n" :order-md="order">
        <v-row>
            <v-col class="text-right">
                <router-link to="/custom" class="not-text-decoration">
                    <v-icon large color="">mdi-close</v-icon>
                </router-link>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="(product,p) in filtrados" :key="'product'+p" cols="4" md="3" class="text-center">
                <router-link :to="'/custom/product/'+product.url" class="not-text-decoration" style="color: black;">
                    <v-img :src="'https://artlesscms.actstudio.xyz'+product.cover.path"></v-img>
                    {{product.name}}
                </router-link>
            </v-col>
        </v-row>
    </v-col>    
</template>

<script>
import goTo from 'vuetify/es5/services/goto'
export default {
    name: 'CustomCategory',
    data(){
        return {
            products: [],
            n: 0
        }
    },
    props:{
        order: 0,
        orderXs: 0
    },
    beforeMount: function() {
        var aux = this;
        fetch(
        "https://www.artlesscms.actstudio.xyz/api/collections/get/CustomProduct?token=a15be93e9cdb43ca2b3778c2077c26",
        {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            filter: {
                active: true
            },
            populate: 1 // resolve linked collection items
            })
        }
        )
        .then(res => res.json())
        .then(res => (this.products = res.entries))

        //this.$route.params.url
    },
    computed: {
        filtrados: function(){
            if(this.$route.params.url == 'all'){
                return this.products;
            }else{
                return this.products.filter(prod => prod.category.url == this.$route.params.url);
            }
        }
    },
    mounted: function(){
        this.$emit("update", 2);
        // setTimeout(() => {
        //     goTo('#category-prod-'+this.n);
            
        // }, 1000);

        var aux = this;
        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Custom '+aux.$route.params.url,
        'page_path': '/custom/category/'+aux.$route.params.url
        });
    },
    watch: {
        $route(to, from) {
            this.n = this.n + 1;

            setTimeout(() => {
                goTo('#category-prod-'+this.n);
            }, 500);

        }
    }
}
</script>